import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import { storage } from "../firebase/firebase";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import UploadIcon from '../component/Icons/uploadIcon.jsx'
import DeleteIcon from '../component/Icons/deleteIcon.jsx'
import { strings } from "../utils/strings.js";


const UploadImage = ({ onImageUpload, blogId, imageType, initialImageUrl }) => {
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(initialImageUrl || "");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    // Set initial image if available
    if (initialImageUrl) {
      setImageUrl(initialImageUrl);
    }
  }, [initialImageUrl]);

  const handleDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file && ["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
      setImage(file);
      const url = await uploadToFirebase(file);
      onImageUpload(url, file);
      setImageUrl(url); // Update the preview URL
    } else {
      alert("File extension must be jpg, jpeg, or png");
    }
  };

  const uploadToFirebase = async (file) => {
    try {
      setUploading(true);
      const imageRef = ref(storage, `${imageType}/${blogId || "new"}-${file.name}`);
      await uploadBytes(imageRef, file);
      const url = await getDownloadURL(imageRef);
      setUploading(false);
      return url;
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploading(false);
      alert("Failed to upload image.");
      return null;
    }
  };

  const handleDelete = async () => {
    if (!imageUrl) return;

    try {
      const imageRef = ref(storage, imageUrl);
      await deleteObject(imageRef);
      setImageUrl(""); // Clear the preview
      onImageUpload(null, null); // Reset image URL in the parent
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Failed to delete image.");
    }
  };

  return (
    <div className="rounded-lg bg-white">
      {imageUrl ? (
        <div className="flex flex-col items-center border rounded-lg p-6">
          <img src={imageUrl} alt="Uploaded preview" width={300} height={200} />
          <button onClick={handleDelete} variant="noStyle" className="mt-5">
            <span className="inline-block transition-transform duration-200 ease-in-out hover:scale-110">
              <DeleteIcon />
            </span>
          </button>
        </div>
      ) : (
        <Dropzone onDrop={handleDrop} multiple={false}>
          {({ getRootProps, getInputProps, isDragActive }) => (
            <section
              className={`w-full rounded-lg border-2 flex justify-center items-center h-32 ${
                isDragActive ? "bg-gray-100" : ""
              }`}
            >
              <div {...getRootProps()} className="flex flex-col items-center">
                <input {...getInputProps()} />
                <UploadIcon />
                <div className="flex justify-center pt-3">
                  <p className="text-sm text-primary font-semibold">{strings["uploadDesc1"]}</p>
                  <p className="text-sm">{strings["uploadDesc2"]}</p>
                </div>
                <p className="text-sm">{strings["uploadDesc3"]}</p>
              </div>
            </section>
          )}
        </Dropzone>
      )}
      {uploading && <p className="text-sm text-gray-500 pt-2 bg-border">Uploading image...</p>}
    </div>
  );
};

export default UploadImage;
